import { useTranslation } from 'react-i18next';

import { useGetCases } from '@/hooks/api/use-get-cases';
import { useUserProfile } from '@/states/user-profile';

import { Section } from '@/components/content-layout/section';
import { SectionHeader } from '@/components/content-layout/section-header';
import { FetchStates } from '@/components/fetch-states';
import { CasesTable } from '@/components/cases/cases-table';

export function InsightsListPage() {
  const { t } = useTranslation();
  const { cases, loading, error } = useGetCases();
  const { profile } = useUserProfile();

  const empty = !profile.clinic || !cases || cases.length === 0;

  return (
    <Section>
      <SectionHeader title={t('nav-insights')} element="h1" />
      <FetchStates loading={loading} error={error?.message} empty={empty} reloadOnError>
        <div className="page-content">
          <CasesTable cases={cases ?? []} mode="insights" />
        </div>
      </FetchStates>
    </Section>
  );
}
